import { mountBooklistCollectIsland } from './booklist-collect'

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountBooklistCollectIsland())
  } else {
    mountBooklistCollectIsland()
  }
}
